export default __webpack_public_path__ + "static/media/pro-elevate-wht-banner-2.3da09458.jpg";